import request from '@/utils/request'

let Ma_student_classificationApi = {

  /*培训学员分类列表*/
  list(data) {
    return request._post('/shop/plus.ma_student_classification.Index/index', data);
},
/*添加培训学员分类*/
add(data) {
    return request._post('/shop/plus.ma_student_classification.Index/add', data);
},
/*修改培训学员分类*/
edit(data) {
    return request._post('/shop/plus.ma_student_classification.Index/edit', data);
},
/*删除培训学员分类*/
del(data) {
    return request._post('/shop/plus.ma_student_classification.Index/del', data);
},
/*培训学员分类详情*/
detail(data) {
  return request._post('/shop/plus.ma_student_classification.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.ma_student_classification.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.ma_student_classification.Setting/getSetting', data, errorback);
    },
}
export default Ma_student_classificationApi;



// WEBPACK FOOTER //
// ./src/api/ma_student_classification.js